import React from 'react';

const ActiveGroupContext = React.createContext({
  setActiveGroup: () => {},
  activeGroup: {},
  accessibleGroups: [],
});

export default ActiveGroupContext;
